import './css/Products.css';

function Products() {
    return (
        <div className='sectionmy-5' id='products'>
            <div className='container'>
                <div className='products p-2 parallax_box'>
                    <div className='mb-5' id='products-top'>
                        <span id='neex-products'>事業・製品案内</span><br></br>
                    </div>
                    <div>
                        <h3 className='mb-3'>システムインテグレーション</h3>
                        <p>
                            ■システムコンサルティング<br/>
                            コンサルティング/プロジェクトマネージメント
                        </p>
                        <p>
                            ■システム開発<br/>
                            Java/PHP/GO/Phython/Ruby/C/.NET/Kotlin等<br/>
                            各種言語を使用したシステム開発
                        </p>
                        <p>
                            ■基盤開発システム<br/>
                            Linux/Windows/Linuxを基盤としたシステム基盤の構築
                        </p>
                    </div>
                    <div>
                        <h3 className='mb-3'>製品一覧</h3>
                        <p>
                            ■システム開発支援<br/>
                            コンサルティング
                        </p>
                        <p>
                            ■パッケージアプリケーション<br/>
                            顧客管理パッケージ/予約支援パッケージ
                        </p>
                        <p>
                            ■携帯端末向けアプリケーション<br/>
                            iOSアプリケーション
                        </p>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Products;
